import PropTypes from "prop-types";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import {
  DataTableEmptyStateContainer,
  DataTableEmptyStateHint,
  DataTableEmptyStateIconWrap,
  DataTableEmptyStateTitle,
} from "./DataTable.styles";

const DataTableEmptyState = ({ title, hint }) => (
  <DataTableEmptyStateContainer data-table-empty-state>
    <DataTableEmptyStateIconWrap>
      <SearchOutlinedIcon />
    </DataTableEmptyStateIconWrap>
    <DataTableEmptyStateTitle>{title}</DataTableEmptyStateTitle>
    {hint ? <DataTableEmptyStateHint>{hint}</DataTableEmptyStateHint> : null}
  </DataTableEmptyStateContainer>
);

DataTableEmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  hint: PropTypes.string,
};

export default DataTableEmptyState;
